import { InjectionKey } from 'vue';
import { Store, createStore, useStore as baseUseStore } from 'vuex';

import { RootState } from '@/models/main';

import { actions } from './actions';
import { moduleNotifications } from './modules/notifications/notifications';
import { moduleScheduler } from './modules/scheduler';
import { moduleSocket } from './modules/socket/socket';
import { mutations } from './mutations';
import { state } from './state';

export const key: InjectionKey<Store<RootState>> = Symbol('store');

export const store = createStore<RootState>({
  modules: {
    moduleScheduler,
    moduleSocket,
    moduleNotifications,
  },
  state: state as RootState,
  getters: {},
  mutations,
  actions,
});

export function useStore(): Store<RootState> {
  return baseUseStore(key);
}

export default store;
